module.exports = __webpack_public_path__ + "img/1543294879.a21848b5.jpg";